import { Button, TextInput } from "@dealer-center/core-components";
import { useState } from "react";
import styled from "styled-components";

const StyledInputArea = styled.div``;

const StyledTextInput = styled(TextInput)`
  margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
  margin-bottom: 1rem;
`;

interface PagesTedsSandboxPageUiInputProps {
  submit: ({ phone, name }: { phone: string; name: string }) => void;
}

export const PagesTedsSandboxPageUiInput = ({
  submit
}: PagesTedsSandboxPageUiInputProps) => {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  return (
    <StyledInputArea>
      <StyledTextInput
        required
        label={"Name"}
        name={"PagesTedsSandboxPageUiTextInput"}
        placeholder="enter name"
        value={name}
        onChange={e => setName(e.target.value)}
      />
      <StyledTextInput
        required
        label={"Phone"}
        name={"PagesTedsSandboxPageUiPhoneInput"}
        placeholder="enter phone"
        value={phone}
        onChange={e => setPhone(e.target.value)}
      />
      <StyledButton
        analyticsConfiguration={{
          eventName: "Submit"
        }}
        onClick={() => {
          submit({ phone, name });
        }}
      >
        Submit
      </StyledButton>
    </StyledInputArea>
  );
};
